//Angular
import { Component, OnInit, ViewContainerRef, Injector, Renderer, ComponentFactory, Input, ReflectiveInjector, Compiler, Inject } from "@angular/core";
import { Router } from "@angular/router";

//Models
import { Menu } from "./../../../../models/cms/menu";
import { MegaMenu } from "./../../../../models/inventory/inventory";

//Services
import { LanguageService } from "./../../../../services/cms/language.service";
import { CategoryService } from "./../../../../services/inventory/category.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";


@Component({
    selector: "dy-side-bar",
    template: ""
})

export class SideBarMenuComponent implements OnInit 
{
    constructor
    (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private cmsComponentService: CmsComponentService,
        @Inject('isBrowser') private isBrowser: boolean
    ) {}

    @Input() sideType: string = "sideBarMenu";
    @Input() parentSideMenuData: any;
    @Input() bredcrumpInfo: Array<any>;

    ngOnInit() 
    {
        if(!this.isBrowser)
            return;

        if (this.parentSideMenuData != null) 
        {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentSideMenuData,this.bredcrumpInfo);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }

        else 
        {
            let subComponentTemplateUrl: string = "sideBarMenuTemplate";

            this.cmsComponentService.getSideMenuData().subscribe(result =>   
            {
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(result,this.bredcrumpInfo);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            });
        }    
    }

    private createSubComponent(data: any,breadcrumbs:Array<any>) 
    {
        @Component({
            template: data.TemplateHtml
        })

        class ChildComponent implements OnInit 
        {
            constructor() {}

            megaMenuItems: any = data.Categories;
          
            breadcrumbsList: Array<any> = new Array<any>() ;

            ngOnInit() 
            {
                if(breadcrumbs!=null)
                {
                    this.breadcrumbsList=breadcrumbs;
                }
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/homepage/widget/side-bar-menu.component.ts